import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Question18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_671)'>
      <path
        d='M9.05344 5.74145C8.27409 5.71145 7.60651 6.35672 7.61 7.13664L6.11001 7.14336C6.10275 5.5218 7.49074 4.1802 9.11112 4.24256C10.7315 4.30491 12.0123 5.74921 11.8804 7.36541C11.838 7.88502 11.6559 8.38349 11.3532 8.808C11.0578 9.22239 10.6584 9.55124 10.1954 9.76157C9.71991 10.0346 9.75001 10.5294 9.75001 11H8.25001C8.25001 10.4211 8.26532 9.87123 8.56186 9.35056C8.78462 8.95944 9.1407 8.58663 9.5586 8.40323C10.0178 8.20169 10.3446 7.74328 10.3854 7.24344C10.4488 6.4661 9.83279 5.77144 9.05344 5.74145Z'
        fill='currentColor'
      />
      <path
        d='M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44771 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25ZM1.75 9C1.75 4.99594 4.99594 1.75 9 1.75C13.0041 1.75 16.25 4.99594 16.25 9C16.25 13.0041 13.0041 16.25 9 16.25C4.99594 16.25 1.75 13.0041 1.75 9Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_671'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Question18.displayName = 'Question18';
export default Question18;
